import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: ':country/:language',
    children: [
      {
        path: 'liat-activation',
        loadChildren: () => import('./features/liat-activation/liat-activation.module').then((m) => m.LiatActivationModule),
      },
      {
        path: '**',
        redirectTo: 'liat-activation',
        pathMatch: 'full',
      },
    ],
  },
  // when a path is not found, redirect to "liat-activation"
  {
    path: '**',
    loadChildren: () => import('./features/liat-activation/liat-activation.module').then((m) => m.LiatActivationModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
